/**
 * @method getLocalTracks
 * @return {Array} List of active Track objects added to the Peer locally.
 */
export default function localTracks () {
  const { proxyPeer, trackManager, log } = this
  log.info('Getting local tracks.')

  // Return the list of Tracks from active senders.
  return (
    proxyPeer
      .getSenders()
      /**
       * Remove any Senders that do not have an associated track.
       * We only want to retrieve Senders that do have tracks, because those are
       *    the local tracks that have been added to the Peer.
       * Senders without tracks are part of a Transceiver where the Receiver has
       *    a remote track, but no local track has been added to it. We don't
       *    care about this for the "get local tracks" operation.
       */
      .filter(sender => Boolean(sender.track))
      .map(sender => trackManager.get(sender.track.id))
      .filter(track => {
        // Make sure the trackManager has the track and that its active.
        // It's possible that Peer has the sender but not the actual track yet.
        return track && track.getState().state === 'live' && track.getStream().active
      })
  )
}
